// Tiện ích màu line chart dashboard (API thật — map trạng thái / DVVC + fallback palette).

export const DVVC_LABELS = [
  { key: "runner", label: "Runner" },
  { key: "vnpost", label: "VNPost" },
  { key: "viettelpost", label: "Viettel Post" },
  { key: "nhattin", label: "Nhất Tín" },
  { key: "netpost", label: "Netpost" },
  { key: "cpn247", label: "247Express" },
  { key: "bus", label: "Chành/Nhà xe" },
  { key: "collector", label: "Collector" },
  { key: "dongom", label: "Đơn gom" },
];

export const TREND_LINE_COLORS = [
  "#2196F3",
  "#E91E63",
  "#9C27B0",
  "#F44336",
  "#FF9800",
  "#FFEB3B",
  "#4CAF50",
  "#00BCD4",
  "#3F51B5",
  "#FF5722",
  "#8BC34A",
  "#607D8B",
];

const STATUS_COLOR_MAP = {
  1: "#AFB42B",
  2: "#D32F2F",
  3: "#F4511E",
  4: "#00897B",
  5: "#1E88E5",
  6: "#00ACC1",
  7: "#5E35B1",
  8: "#FB8C00",
  9: "#FDD835",
};

const STATUS_LABEL_TO_CODE = {
  "Tạo đơn": 1,
  "Đã điều phối": 2,
  "Đã nhận hàng": 3,
  "Đã giao hàng": 4,
  "Hoàn tất": 5,
  "Đang chờ": 6,
  "Hủy đơn": 7,
  "Đến hub": 8,
  "Trung chuyển": 9,
};

const DVVC_COLOR_MAP = {
  runner: "#3F51B5",
  vnpost: "#E53935",
  viettelpost: "#FF6F00",
  nhattin: "#8E24AA",
  netpost: "#00ACC1",
  cpn247: "#43A047",
  bus: "#795548",
  collector: "#009688",
  dongom: "#E91E63",
};

function hashSeed(parts) {
  const s = parts.filter(Boolean).join("|");
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

// Màu đường theo id trạng thái, label tiếng Việt, hoặc key DVVC; không khớp thì chọn theo hash label.
export function getTrendLineColorForLabel(label) {
  const t = (label || "").toString().trim();

  const asNum = Number(t);
  if (!isNaN(asNum) && STATUS_COLOR_MAP[asNum]) return STATUS_COLOR_MAP[asNum];

  const codeFromLabel = STATUS_LABEL_TO_CODE[t];
  if (codeFromLabel) return STATUS_COLOR_MAP[codeFromLabel];

  const dvvcKey = t.toLowerCase();
  if (DVVC_COLOR_MAP[dvvcKey]) return DVVC_COLOR_MAP[dvvcKey];

  const matchedDvvc = DVVC_LABELS.find(d => d.label.toLowerCase() === dvvcKey || d.key === dvvcKey);
  if (matchedDvvc) return DVVC_COLOR_MAP[matchedDvvc.key];

  const h = hashSeed([t]);
  return TREND_LINE_COLORS[h % TREND_LINE_COLORS.length];
}
